import { useState } from "react";

const DeleteSelectedEntriesModal = ({ isOpen, onCancel, onConfirm }) => {
   
  

  return (
    <div className={`w-full bg-pink-100 transition-all duration-1000 overflow-hidden ${
        isOpen ? "max-h-[1000px] opacity-100 scale-100" : "max-h-0 opacity-0 scale-100"
      }`}>
      <div className="bg-white p-6 rounded-lg shadow-xl  text-center">
        <p>Are you sure you want to delete?</p>
        <div className="flex justify-center mt-4 space-x-3">
          <button
            onClick={onCancel}
            className="text-xs px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition"
          >
            CANCEL
          </button>
        <button
  onClick={onConfirm}
  
  className={`text-xs px-4 py-2 rounded-md transition 
    ${!true ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}`}
>
  CONFIRM DELETE 
</button>
        </div>
      </div>
    </div>
  );
};
export default DeleteSelectedEntriesModal;


